import SystemActions from 'utils/roles/SystemActions';

export default class PublicRole extends SystemActions {
  constructor(payload) {
    super();
    this.payload = payload;
  }
}
